var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.108,
    height: 15.031,
    viewBox: "0 0 15.108 15.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6655",
    "data-name": "Group 6655",
    transform: "translate(5668 10181.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 15,
    height: 15,
    transform: "translate(-5668 -10181)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 15,
    height: 15,
    transform: "translate(-5667.892 -10181.021)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M11.268,0l-.6,4.732,4.357,1.84-4.357,1.84.6,4.732L7.512,10.254,3.756,13.146l.6-4.732L0,6.573l4.357-1.84L3.756,0,7.512,2.892Z",
    transform: "translate(-5653.926 -10181.013) rotate(90)",
    fill: "#ffa539"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMessage);
export default __webpack_public_path__ + "static/media/StarMessage.7d6ad48f2204a5b1aef0efbc1375b453.svg";
export { ForwardRef as ReactComponent };